import { render } from "./desktop-footer.vue?vue&type=template&id=4380f009&scoped=true"
const script = {}

import "../../../assets/css/desktop.css?vue&type=style&index=0&id=4380f009&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4380f009"

export default script